export const listRecipes = /* GraphQL */ `
  query ListRecipes($userId: ID!) {
    listRecipes(userId: $userId) {
      userId
      recipeId
      title
      description
      servings
      ingredients {
        name
        amount
        unit
        isCannabisInfused
        cannabinoidPercentage
        cannabinoidType
        materialWeight
        decarboxylationEfficiency
        extractionEfficiency
      }
      instructions
      totalCannabinoidMg
      perServingMg
      createdAt
      updatedAt
    }
  }
`;

export const getRecipe = /* GraphQL */ `
  query GetRecipe($userId: ID!, $recipeId: ID!) {
    getRecipe(userId: $userId, recipeId: $recipeId) {
      userId
      recipeId
      title
      description
      servings
      ingredients {
        name
        amount
        unit
        isCannabisInfused
        cannabinoidPercentage
        cannabinoidType
        materialWeight
        decarboxylationEfficiency
        extractionEfficiency
      }
      instructions
      totalCannabinoidMg
      perServingMg
      createdAt
      updatedAt
    }
  }
`;

export const createRecipe = /* GraphQL */ `
  mutation CreateRecipe($input: CreateRecipeInput!) {
    createRecipe(input: $input) {
      userId
      recipeId
      title
      description
      servings
      ingredients {
        name
        amount
        unit
        isCannabisInfused
        cannabinoidPercentage
        cannabinoidType
        materialWeight
        decarboxylationEfficiency
        extractionEfficiency
      }
      instructions
      totalCannabinoidMg
      perServingMg
      createdAt
      updatedAt
    }
  }
`;

export const updateRecipe = /* GraphQL */ `
  mutation UpdateRecipe($input: UpdateRecipeInput!) {
    updateRecipe(input: $input) {
      userId
      recipeId
      title
      description
      servings
      ingredients {
        name
        amount
        unit
        isCannabisInfused
        cannabinoidPercentage
        cannabinoidType
        materialWeight
        decarboxylationEfficiency
        extractionEfficiency
      }
      instructions
      totalCannabinoidMg
      perServingMg
      createdAt
      updatedAt
    }
  }
`;

export const deleteRecipe = /* GraphQL */ `
  mutation DeleteRecipe($input: DeleteRecipeInput!) {
    deleteRecipe(input: $input) {
      userId
      recipeId
      title
      description
      servings
      ingredients {
        name
        amount
        unit
        isCannabisInfused
        cannabinoidPercentage
        cannabinoidType
        materialWeight
        decarboxylationEfficiency
        extractionEfficiency
      }
      instructions
      totalCannabinoidMg
      perServingMg
      createdAt
      updatedAt
    }
  }
`;
